import { DraggableComponent, Vector, } from "@inter-ikea-core/core";
import { getIpexViewer } from "@inter-ikea-core/ipex-betrakta-core-adapter";
import { getEntitySize } from "../utils/getEntityData";
import { CANT_CREATE_VIEWER_OBJECT, NO_VIEWER, } from "@inter-ikea-storagetwo/range/dist/constants/errors";
const getViewer = (core) => {
    const viewer = getIpexViewer(core.services.sceneManager);
    if (!viewer)
        throw new Error(NO_VIEWER);
    return viewer;
};
const setupViewerObject = (uprightViewerObject, viewerObject) => {
    uprightViewerObject.setVisible(true);
    uprightViewerObject.setTransparency(0);
    const position = uprightViewerObject.getPosition();
    uprightViewerObject.setPosition(new Vector(position.X, position.Y, position.Z));
    uprightViewerObject.setParent(viewerObject);
    uprightViewerObject.registerInputEvents();
};
const addObservableToViewerObject = (uprightViewerObject, viewer, entity) => {
    const viewerObjectId = uprightViewerObject.getViewerObjectId();
    viewer
        .get_object_pointer_enter_observable(viewerObjectId)
        .add(() => (document.body.style.cursor = "col-resize"));
    viewer
        .get_object_pointer_leave_observable(viewerObjectId)
        .add(() => (document.body.style.cursor = ""));
    viewer.get_object_drag_begin_observable(viewerObjectId).add(() => {
        viewer
            .get_object_pointer_leave_observable(viewerObjectId)
            .add(() => (document.body.style.cursor = "col-resize"));
        entity.addComponent(new DraggableComponent());
    });
    viewer.get_object_drag_end_observable(viewerObjectId).add(() => {
        viewer
            .get_object_pointer_leave_observable(viewerObjectId)
            .add(() => (document.body.style.cursor = ""));
        document.body.style.cursor = "";
    });
};
export const addInteractableViewerObjectToUpright = (entity, core, viewerObject) => {
    var _a;
    const viewer = getViewer(core);
    const uprightSize = getEntitySize(entity);
    const uprightViewerObject = (_a = core.modules
        .viewer()) === null || _a === void 0 ? void 0 : _a.createBox(uprightSize.X, uprightSize.Y, uprightSize.Z, entity);
    if (!uprightViewerObject)
        throw new Error(CANT_CREATE_VIEWER_OBJECT);
    setupViewerObject(uprightViewerObject, viewerObject);
    addObservableToViewerObject(uprightViewerObject, viewer, entity);
};
